import { fetchAuthSession } from 'aws-amplify/auth';

import Log from '@/Logger';

/**
 * 現在のアクセストークンを取得
 * Amplify の認証システムから取得する
 */
export async function getAccessToken(): Promise<string> {
    const logger = Log.getLogger();

    try {
        const session = await fetchAuthSession();

        if (!session.tokens) {
            throw new Error('No authentication tokens found');
        }

        const accessToken = session.tokens.accessToken.toString();

        if (!accessToken) {
            throw new Error('Access token is empty');
        }

        logger.api.debug('API Client', 'Auth', 'Access token retrieved successfully');
        return accessToken;

    } catch (error) {
        logger.api.error('API Client', 'Auth Error', `Failed to get access token: ${error}`);
        throw new Error('認証エラーが発生しました。再ログインしてください。');
    }
}


/**
 * 現在のIDトークンを取得
 * Amplify の認証システムから取得する
 */
export async function getJWT(): Promise<string> {
    const logger = Log.getLogger();

    try {
        const session = await fetchAuthSession();

        if (!session.tokens) {
            throw new Error('No authentication tokens found');
        }

        if (!session.tokens.idToken) {
            throw new Error('ID token is empty');
        }

        return session.tokens.idToken.toString();

    } catch (error) {
        logger.api.error('API Client', 'Auth Error', `Failed to get access token: ${error}`);
        throw new Error('認証エラーが発生しました。再ログインしてください。');
    }
}


/**
 * ユーザーがログインしているかどうかを確認
 */
export async function isAuthenticated(): Promise<boolean> {
    try {
        const session = await fetchAuthSession();
        return !!(session.tokens && session.tokens.accessToken);
    } catch {
        return false;
    }
}

/**
 * 認証トークン文字列を生成
 */
export async function getAuthToken(): Promise<string> {
    const accessToken = await getAccessToken();
    return `Bearer ${accessToken}`
}

/**
 * 認証ヘッダーを生成
 */
export async function getAuthHeaders(): Promise<Record<string, string>> {
    return {
        'Authorization': await getAuthToken(),
    };
}
